module.exports = __webpack_public_path__ + "static/media/EE_kurir.5831acd8.svg";